import { create } from "zustand";

interface RefreshStoreState {
  isRefreshing: boolean;
  setIsRefreshing: (value: boolean) => void;
}

export const useRefreshStore = create<RefreshStoreState>((set) => ({
  isRefreshing: false,
  setIsRefreshing: (value: boolean) => set({ isRefreshing: value }),
}));
